import { Routes } from '@angular/router';
import { MsalRedirectComponent } from '@azure/msal-angular';
import { ShellLayout } from './components/shell-layout/shell-layout';
import { authGuard, loginGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: 'auth',
    component: MsalRedirectComponent,
  },
  {
    path: 'login',
    canActivate: [loginGuard],
    loadComponent: () => import('./components/login-page/login-page').then((m) => m.LoginPage),
  },
  {
    path: '',
    component: ShellLayout,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./components/home/home').then((m) => m.Home),
      },
      {
        path: 'monthly-reports',
        loadComponent: () =>
          import('./components/monthly-reports/monthly-reports').then((m) => m.MonthlyReports),
      },
      {
        path: 'billing',
        loadComponent: () =>
          import('./components/billing-analysis/billing-analysis').then((m) => m.BillingAnalysis),
      },
      {
        path: 'po-processing',
        loadComponent: () => 
          import('./components/po-processing/po-processing').then((m) => m.PoProcessing),
      },
      {
        path: 'master-data',
        loadComponent: () =>
          import('./components/master-data/master-data').then((m) => m.MasterData),
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./components/dashboard/dashboard').then((m) => m.Dashboard),
      },
      {
        path: 'forecast',
        loadComponent: () =>
          import('./components/forecast-workspace/forecast-workspace').then((m) => m.ForecastWorkspace),
      },
      {
        path: 'lb-reports',
        loadComponent: () =>
          import('./components/lb-reports/lb-reports').then((m) => m.LbReports),
      },
    ],
  },

  { path: '**', redirectTo: 'login' },
];
